export const unitCodes = [
    {unidad: "Pz", codigo_unidad: "H87"},
    {unidad: "Caja", codigo_unidad: "XBX"}
]

export const unitCodes_granel = [
  {unidad: "Kg", codigo_unidad: "KGM"},
  {unidad: "Lt", codigo_unidad: "LTR"},
  {unidad: "Costal", codigo_unidad: "KGM"},
]